import React, { useState } from "react";

const ServicesInputForm = () => {
  const [service, setService] = useState({});
  const [toast, setToast] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    console.log(service);

    //send or create or post  data to server
    fetch("https://spooky-journalist-server.vercel.app/services", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(service),
    })
      .then((res) => res.json())
      .then((data) => {
        data.acknowledged ? setToast(true) : setToast(false)
      } );
    form.reset();
    
  };
  const handleBlur = (e) => {
    e.preventDefault();
    const form = e.target;
    const fieldName = form.name;
    const fieldValue = form.value;
    const newService = { ...service };
    newService[fieldName] = fieldValue;
    setService(newService);
  };

  return (
    <div className="mx-auto max-w-7xl text-center">
      {toast && (
        <div className="toast toast-end toast-middle">
        <div className="alert alert-success">
          <div>
            <span>Message sent successfully.</span>
          </div>
        </div>
      </div>
      )}
      <form className="" onSubmit={handleSubmit}>
        <div className="overflow-hidden shadow sm:rounded-md ">
          <div className="bg-white px-4 py-5">
            <label className="label">
              <span className="label-text text-center">
                Enter Service Title
              </span>
            </label>
            <input
              onBlur={handleBlur}
              type="text"
              name="title"
              placeholder="Type here"
              className="input input-bordered input-success w-1/2  "
            />
          </div>
          <div className="bg-white px-4 py-5">
            <label className="label">
              <span className="label-text">Enter Service Description</span>
            </label>
            <input
              onBlur={handleBlur}
              type="text"
              name="description"
              placeholder="Type description"
              className="input input-bordered input-success w-1/2  "
            />
          </div>
          <div className="bg-white px-4 py-5">
            <label className="label">
              <span className="label-text">Service Photo URL</span>
            </label>
            <input
              onBlur={handleBlur}
              type="text"
              name="photo"
              placeholder="Photo url"
              className="input input-bordered input-success w-1/2  "
            />
          </div>
          <div className="bg-white px-4 py-5 ">
            <label className="label">
              <span className="label-text">Enter Service Price</span>
            </label>
            <input
              onBlur={handleBlur}
              type="text"
              name="price"
              placeholder="Type Price"
              className="input input-bordered input-success w-1/2  "
            />
          </div>
          <div className="bg-white px-4 py-5 ">
            <label className="label">
              <span className="label-text">Enter Service Selling Quantity</span>
            </label>
            <input
              onBlur={handleBlur}
              type="text"
              name="quantity"
              placeholder="Type quantity"
              className="input input-bordered input-success w-1/2  "
            />
          </div>

          <div className="bg-gray-50 px-4 py-3 text-center sm:px-6">
            <button
              type="submit"
              className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ServicesInputForm;
